import React, { useEffect, useRef, useState, useContext } from 'react';
import { Body, Header, Main } from '../../NecttosComp/Layout/Layout';
import Button from '../../NecttosComp/Button/Button';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { useQuery } from 'react-query';
import { Table, Tbody, Td, Th, Thead, Tr, useSortableData } from '../../NecttosComp/Table/Table';
import moment from 'moment';
import toast from 'react-hot-toast';
import Input2 from '../../NecttosComp/Input/Input2';
import { FirebaseContext } from '../../context/FirebaseContext';
import Instruction from '../../Documentation/Instruction';

interface TaskTrackerProps {
	onClose: () => void;
}

function TaskTracker({ onClose }: TaskTrackerProps) {
	const { userId, role } = useContext(FirebaseContext);
	const ref = useRef<any>(null);
	const [formData, setFormData] = useState({
		collegeId: '',
		userId: userId || '',
		area: '',
		description: '',
		satisfaction: '',
		startDate: '',
		startTime: '',
		endDate: '',
		endTime: '',
		status: '',
	});
	const [showForm, setShowForm] = useState(false);
	const [taskData, setTaskData] = useState<any[]>([]);
	const [selectedFormData, setSelectedFormData] = useState<any>(null);
	const [staff, setStaff] = useState<any[]>([]);
	const [search, setSearch] = useState('');

	useEffect(() => {
		fetchUsersByCollege(formData.collegeId);
	}, []);

	const fetchUsersByCollege = async (collegeId: string) => {
		try {
			const instance = await getAxiosTokenInstance();
			const response = await instance.get(`/college/office/getNamesByCollegeId?collegeId=COL-23D0120D7F2F-4BC1-91F8-D46B399136E3`);
			console.log('Users fetched:', response.data.users);
			setStaff(response.data.users);
		} catch (error) {
			console.error('Error fetching users by college:', error);
		}
	};

	const fetchTasks = async () => {
		try {
			const instance = await getAxiosTokenInstance();
			const response = await instance.get('/college/office/tasks/getAll');
			setTaskData(response.data.tasks);
		} catch (error) {
			console.error('Error fetching bugs:', error);
		}
	};

	const fetchTasksForStaff = async () => {
		try {
			const instance = await getAxiosTokenInstance();
			const response = await instance.get(`/college/office/tasks/getByUserId?userId=${userId}`);
			setTaskData(response.data.tasks);
		} catch (error) {
			console.error('Error fetching tasks for staff:', error);
		}
	};

	useEffect(() => {
		fetchTasks();
	}, []);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
		const { name, value } = e.target;
		setFormData((prevData) => ({
			...prevData,
			[name]: value,
		}));
	};

	const { data: tasks = [], isLoading, error, refetch } = useQuery('tasks', fetchTasks);

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		try {
			const response = await (await getAxiosTokenInstance()).post('/college/office/tasks/add', formData);
			if (response.data && response.data.message === 'Task added successfully!') {
				refetch();
				setFormData({
					collegeId: '',
					userId: '',
					area: '',
					description: '',
					satisfaction: '',
					startDate: '',
					startTime: '',
					endDate: '',
					endTime: '',
					status: '',
				});
				setShowForm(false);
				toast.success('Task added successfully!');
			} else {
				toast.error('Failed to add task');
			}
		} catch (error) {
			console.error('Error submitting task', error);
			toast.error('Error submitting task');
		}
	};

	const handleCloseModal = () => {
		setSelectedFormData(null);
	};

	const handleRowClick = (task: any) => {
		setSelectedFormData(task);
	};
	console.log(formData);
	const filteredTasks = search
	? taskData.filter((task) =>
			[task.userName, task.area, task.status]
				.join(' ')
				.toLowerCase()
				.includes(search.toLowerCase())
	  )
	: taskData;

		const { tableItems, requestSort, getIcon } = useSortableData(filteredTasks || []);
	// console.log('tableItems', tableItems);
	

	return (
		<Main title='Task Tracker' width='100%' height='100%'>
			<Header>
				<div className='flex'>
					<Button type='save' onClick={() => setShowForm(true)}>
						Add Task
					</Button>
					<Input2 type={'text'} fieldName='Search' state={search} setState={setSearch} className='w-[300px] h-[40px] border-0'  />
				</div>
				<div className='flex'>
					<Button type='print' tableRef={ref.current}>
						Print
					</Button>
					<Button type='excel' tableRef={ref.current}>
						Excel
					</Button>
					<Instruction keyId={'TaskTracker'}/>
					<Button type='close' onClick={onClose}>
						Close
					</Button>
				</div>
			</Header>

			<Body>
				{showForm ? (
					<form onSubmit={handleSubmit}>
						<div className='flex justify-center items-center h-full'>
							<div className='w-[95%] p-8 bg-slate-100 dark:bg-neutral-800 dark:text-white rounded-xl shadow-lg mt-4'>
								<h2 className='text-2xl font-bold mb-4 dark:text-white'>Add Task</h2>
								<div className='grid grid-cols-3 gap-6 mb-4'>
									<Input2 className='w-full' valueShowKey='name' returnKey='userId' optionDisplay='name' optionKey='_id' options={staff || []} didntShowKey fieldName='User Name' type='drop' state={formData} setState={setFormData} required />

									<Input2 width='400px' className='w-full' inputValue={formData.area} returnKey='area' fieldName='area' type='drop' options={['Programming', 'Office Work', 'On-Site']} state={formData} setState={setFormData} />

									<Input2 className='w-full' inputValue={formData.description} returnKey='description' fieldName='Description' type='text' state={formData} setState={setFormData} />

									<Input2 width='400px' className='w-full' inputValue={formData.satisfaction} returnKey='satisfaction' fieldName='satisfaction' type='drop' options={['Excellent', 'Very Good', 'Good', 'Average', 'Bad']} state={formData} setState={setFormData} />

									<Input2 className='w-full' inputValue={formData.startDate} returnKey='startDate' fieldName='Start Date' type='date' state={formData} setState={setFormData} />

									<Input2 className='w-full' inputValue={formData.startTime} returnKey='startTime' fieldName='Start Time' type='time' state={formData} setState={setFormData} />

									<Input2 className='w-full' inputValue={formData.endDate} returnKey='endDate' fieldName='End Date' type='date' state={formData} setState={setFormData} />

									<Input2 className='w-full' inputValue={formData.endTime} returnKey='endTime' fieldName='End Time' type='time' state={formData} setState={setFormData} />

									<Input2 width='400px' className='w-full' inputValue={formData.status} returnKey='status' fieldName='status' type='drop' options={['Not Complete', 'Complete']} state={formData} setState={setFormData} />
								</div>

								<div className='flex justify-between mt-4'>
									<Button type='close' onClick={() => setShowForm(false)}>
										Cancel
									</Button>
									<Button type='submit'>Submit</Button>
								</div>
							</div>
						</div>
					</form>
				) : (
					<div ref={ref} className='h-[90vh] pt-2 printable overflow-auto'>
						<Table width='100%' innerWidth={['5%', '20%', '15%', '15%', '15%', '15%', '15%']}>
							<Thead>
								<Tr>
									<Th position={0}>Sl.No.</Th>
									<Th position={1} onClick={() => requestSort('userName')} icon={getIcon('userName')}>User</Th>
									<Th position={2} onClick={() => requestSort('area')} icon={getIcon('area')}>Area</Th>
									<Th position={3} onClick={() => requestSort('satisfaction')} icon={getIcon('satisfaction')}>Satisfaction</Th>
									<Th position={4} onClick={() => requestSort('startDate')} icon={getIcon('startDate')}>Start Date</Th>
									<Th position={5} onClick={() => requestSort('endDate')} icon={getIcon('endDate')}>End Date</Th>
									<Th position={6} onClick={() => requestSort('status')} icon={getIcon('status')}>Status</Th>
								</Tr>
							</Thead>
							<Tbody height='auto'>
								{tableItems.map((task, i) => (
									<Tr key={i} onClick={() => handleRowClick(task)}>
										<Td index={i} position={0}>
											{i + 1}
										</Td>
										<Td index={i} position={1}>
											{task.userName}
										</Td>
										<Td index={i} position={2}>
											{task.area}
										</Td>
										<Td index={i} position={3}>
											{task.satisfaction}
										</Td>
										<Td index={i} position={4}>
											{moment(task.startDate).format('MMM-DD-YYYY')}
										</Td>
										<Td index={i} position={5}>
											{moment(task.endDate).format('MMM-DD-YYYY')}
										</Td>
										<Td index={i} position={6}>
											{task.status}
										</Td>
									</Tr>
								))}
							</Tbody>
						</Table>
					</div>
				)}
			</Body>
			{selectedFormData && (
				<div className='fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center'>
					<div className='bg-slate-100 dark:bg-neutral-800 p-6 rounded-xl shadow-xl w-3/4 max-w-4xl'>
						<h2 className='text-2xl font-semibold text-gray-800 dark:text-white mb-6 text-center'>Task Details</h2>

						<div className='space-y-4'>
							<div className='flex justify-between'>
								<p className='font-medium dark:text-white w-1/3'>
									<strong>User:</strong>
								</p>
								<p className='dark:text-white w-2/3'>{selectedFormData.userName}</p>
							</div>

							<div className='flex justify-between'>
								<p className='font-medium dark:text-white w-1/3'>
									<strong>Area:</strong>
								</p>
								<p className='dark:text-white w-2/3'>{selectedFormData.area}</p>
							</div>

							<div className='flex justify-between'>
								<p className='font-medium dark:text-white w-1/3'>
									<strong>Description:</strong>
								</p>
								<p className='dark:text-white w-2/3'>{selectedFormData.description}</p>
							</div>

							<div className='flex justify-between'>
								<p className='font-medium dark:text-white w-1/3'>
									<strong>Satisfaction:</strong>
								</p>
								<p className='dark:text-white w-2/3'>{selectedFormData.satisfaction}</p>
							</div>

							<div className='flex justify-between'>
								<p className='font-medium dark:text-white w-1/3'>
									<strong>Start Date:</strong>
								</p>
								<p className='dark:text-white w-2/3'>{moment(selectedFormData.startDate).format('MMM-DD-YYYY')}</p>
							</div>

							<div className='flex justify-between'>
								<p className='font-medium dark:text-white w-1/3'>
									<strong>Start Time:</strong>
								</p>
								<p className='dark:text-white w-2/3'>{moment(selectedFormData.startTime, 'HH:mm').isValid() ? moment(selectedFormData.startTime, 'HH:mm').format('hh:mm A') : selectedFormData.startTime}</p>
							</div>

							<div className='flex justify-between'>
								<p className='font-medium dark:text-white w-1/3'>
									<strong>End Date:</strong>
								</p>
								<p className='dark:text-white w-2/3'>{moment(selectedFormData.endDate).format('MMM-DD-YYYY')}</p>
							</div>

							<div className='flex justify-between'>
								<p className='font-medium dark:text-white w-1/3'>
									<strong>End Time:</strong>
								</p>
								<p className='dark:text-white w-2/3'>{moment(selectedFormData.endTime, 'HH:mm').isValid() ? moment(selectedFormData.endTime, 'HH:mm').format('hh:mm A') : selectedFormData.endTime}</p>
							</div>

							<div className='flex justify-between'>
								<p className='font-medium dark:text-white w-1/3'>
									<strong>Status:</strong>
								</p>
								<p className='dark:text-white w-2/3'>{selectedFormData.status}</p>
							</div>
						</div>

						<div className='flex justify-center mt-6'>
							<Button type='close' onClick={handleCloseModal}>
								Close
							</Button>
						</div>
					</div>{' '}
				</div>
			)}
		</Main>
	);
}

export default TaskTracker;
